export enum CUSTOM_INPUT_PARAMETERS_NAMES {
  TARGET_VERSION = "targetVersion",
  FIRMWARE_UID = "firmwareUid",
  INCLUSION_PERIODS = "inclusionPeriods",
}
